import React, { useCallback, useEffect, useState } from "react";
import { IconLockClosedLight, skinVars } from "@telefonica/mistica";
import { strings } from "../../../../localization";
import { observer } from "mobx-react-lite";
import { ValidationOTPToken } from "../../../../components/templates";
import { useGlobalStore } from "../../../../contexts/globalStoreContext";
import { ValidationTypeOTP } from "../../../../enum/validationTypeOTP";
import { useAnalytics } from "../../../../hooks/useAnalytics";
import { useNavigateCustom } from "../../../../hooks";

const ValidateOTPBySMS: React.FC = observer(() => {
	const { validationOTPStore } = useGlobalStore();
	const navigate = useNavigateCustom();
	const [codeOTP, setCodeOTP] = useState("");
	const { title, description } = strings.pages.ValidateTokenOTP;
	const { buttonPrimary, buttonSecondary } = strings.components.buttons;
	const { updatePageView, addAnalyticEvent } = useAnalytics();

	const defaultLabels = strings.organisms.pinInput;

	useEffect(() => {
		updatePageView({ name: "Vivo Money FGTS Confirmar Contratação Esqueci a Senha", pagePath: "/fgts/confirmar-contratacao/esqueci-a-senha" });
		handleSendValidationOTP();
	}, []);

	useEffect(() => {
		if (validationOTPStore.remainingAttempts < 3) {
			addAnalyticEvent({
				event: "non_interaction",
				action: "view-error",
				step: "fgts:confirmar-contracao:senha",
				description: defaultLabels.errorField(validationOTPStore.remainingAttempts),
			}, { applySanitize: true });
		}

	}, [validationOTPStore.remainingAttempts]);

	const handleSendValidationOTP = useCallback(() => {
		setCodeOTP("");
		validationOTPStore.resetRemainingAttempts();
		validationOTPStore.sendValidationOTP(ValidationTypeOTP.PASSWORD_RESET);
	}, [codeOTP, validationOTPStore.resetRemainingAttempts, validationOTPStore.sendValidationOTP]);

	const onBack = (): void => {
		addAnalyticEvent({ action: "click.button",
			step: "fgts:fgts:confirmar-contracao:senha",
			description: buttonSecondary,
		}, { applySanitize: true });
		navigate(-1);
	};

	const handleContinue = async (): Promise<void> => {
		const { isValid } = await validationOTPStore.validateOTP(codeOTP);
		setCodeOTP("");
		addAnalyticEvent({ action: "click.button",
			step: "fgts:fgts:confirmar-contracao:senha",
			description: buttonPrimary,
		}, { applySanitize: true });

		if (isValid) {
			navigate("/sign-contract/forgot-password/password-reset");
		}
	};

	return (
		<ValidationOTPToken
			title={title}
			description={description}
			isDisabled={validationOTPStore.loader.isLoading || validationOTPStore.remainingAttempts <= 0}
			isDisabledInput={validationOTPStore.remainingAttempts <= 0}
			codeOTP={codeOTP}
			icon={<IconLockClosedLight size={64} color={skinVars.colors.brand} />}
			setCodeOtp={setCodeOTP}
			onBack={onBack}
			onResend={handleSendValidationOTP}
			onContinue={handleContinue}
			attempts={validationOTPStore.remainingAttempts}
		/>
	);
});

export default ValidateOTPBySMS;
